import React, { useState } from 'react';

import { CronJobName, CronJobPayload } from '../CronJobsCRUDForm.types';

import { converter } from './utils/converter';
import { tasksCronJobsSchema } from './utils/tasksCronJobsSchema';

import CronJobsCRUD from '../CronJobsCRUD';
import { TasksCronJobsFormContent } from './TasksCronJobsFormContent';

const TasksCronJobs: React.FC = () => {
  const [selectedJobType, changeJobType] = useState<CronJobName>('report');
  const defaultValues: Partial<CronJobPayload> = {
    jobName: selectedJobType,
    importDefinitionId: '',
    period: '',
    cron: '',
    config: {
      tenantId: '',
      minusDays: '0',
      plusDays: '0'
    }
  };

  return (
    <CronJobsCRUD
      schema={tasksCronJobsSchema}
      defaultFormValues={tasksCronJobsSchema.cast(defaultValues)}
      convertData={converter}
    >
      <TasksCronJobsFormContent
        selectedJobType={selectedJobType}
        changeJobType={changeJobType}
      />
    </CronJobsCRUD>
  );
};

export default TasksCronJobs;
